import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import dropdownIcon from '../../Assets/images/svg/drop-down-arrow.svg';
import PropTypes from 'prop-types';

const DropDownIcon = () => <img src={dropdownIcon} alt="dropdown" />;

const AccordionWrapper = ({
  backgroundColor,
  configuration,
  titleClassname,
  accordionClassname,
}) => {
  return Object.values(configuration).map((item) => {
    return (
      <Accordion
        style={{ backgroundColor }}
        sx={{
          marginBottom: 2,
          paddingY: 1,
          borderRadius: '4px',
          boxShadow: 'none',
          border: 'none',
          '&::before': {
            visibility: 'hidden',
          },
        }}
        key={item.title}
        className={accordionClassname}
        expanded= {item.state}
        disableGutters
      >
        <AccordionSummary
          expandIcon={<DropDownIcon />}
          aria-controls={`${item.title}-content`}
          id={`${item.title}`}
          onClick={item.openHandler}
        >
          <Typography component="span" className={titleClassname}>
            {item.title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>{item.data}</AccordionDetails>
      </Accordion>
    );
  });
};

AccordionWrapper.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  configuration: PropTypes.object.isRequired,
  titleClassname: PropTypes.string,
  accordionClassname: PropTypes.string,
};

export default AccordionWrapper;
